
import { Button } from "@/components/ui/button";
import { DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Link } from "react-router-dom";

export const ConstructionMethodsDialog = () => {
  return (
    <DialogContent className="sm:max-w-[600px]">
      <DialogHeader>
        <DialogTitle className="text-2xl">Construction Methods</DialogTitle>
        <DialogDescription>
          Explore different construction methodologies and their applications
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <h3 className="font-semibold text-lg mb-3">Available Construction Methods:</h3>
        
        <div className="space-y-4">
          <div className="border rounded-md p-4 hover:bg-slate-50 transition-colors">
            <h4 className="font-medium text-lg">
              <Link to="/modular-construction" className="text-primary hover:underline">
                Modular Construction
              </Link>
            </h4>
            <p className="text-sm text-muted-foreground mt-1">
              Building components manufactured off-site and then assembled on-site. Includes 25 knowledge bases covering techniques, best practices, and case studies.
            </p>
          </div>
          
          <div className="border rounded-md p-4 hover:bg-slate-50 transition-colors">
            <h4 className="font-medium text-lg">Prefabrication</h4>
            <p className="text-sm text-muted-foreground mt-1">
              Manufacturing building components in a factory setting before transporting them to the construction site.
            </p>
          </div>
          
          <div className="border rounded-md p-4 hover:bg-slate-50 transition-colors">
            <h4 className="font-medium text-lg">3D Printing</h4>
            <p className="text-sm text-muted-foreground mt-1">
              Additive manufacturing techniques used to create building components or entire structures.
            </p>
          </div>
          
          <div className="border rounded-md p-4 hover:bg-slate-50 transition-colors">
            <h4 className="font-medium text-lg">Traditional Construction</h4>
            <p className="text-sm text-muted-foreground mt-1">
              Conventional building methods where most work is performed on-site.
            </p>
          </div>
        </div>
      </div>
    </DialogContent>
  );
};

export default ConstructionMethodsDialog;
